import createClient from "openapi-fetch";
import type { paths } from "./schema.gen";

// В dev Vite проксирует /api → :8000 (см. vite.config.ts), в проде FastAPI
// раздаёт собранную статику с того же origin'а — поэтому baseUrl относительный.
export const api = createClient<paths>({ baseUrl: "" });

// Регистр обработчиков 401: AuthProvider вешает callback, который при
// протухшей сессии сбрасывает состояние и редиректит на /login. Делаем через
// module-level slot, потому что api-клиент создаётся вне React-дерева.
let on401Handler: (() => void) | null = null;

export function setOn401Handler(handler: (() => void) | null): void {
  on401Handler = handler;
}

api.use({
  onResponse({ response }) {
    if (response.status === 401) {
      on401Handler?.();
    }
    return response;
  },
});
